import React from "react";
import Image from "next/image";

const PurposeSection = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[#F8FAFC] dark:bg-[url('/images/our_ecosystem_gradient_dark.png')]" />

      <div className="container mx-auto px-4 relative z-[2]">
        {/* Top Section - Centered Heading */}
        <div className="text-center mb-12">
          <h3 className="text-accent uppercase font-semibold text-lg mb-4 tracking-wide">
            OUR PURPOSE
          </h3>
          <h1 className="text-4xl md:text-5xl font-bold text-grayish dark:text-white leading-snug">
            Where Tech Meets Global Impact
          </h1>
        </div>

        {/* Content Section - Flexbox */}
        <div className="flex flex-col md:flex-row items-center max-w-7xl mx-auto">
          {/* Left Side - Image */}
          <div className="w-full md:w-1/2 mb-8 md:mb-0">
            <div className="max-w-[600px] mx-auto">
              <Image
                src="/images/hero-about/avatar-earth.svg"
                alt="Global Impact"
                width={600}
                height={600}
                className="w-full"
              />
            </div>
          </div>

          {/* Right Side - Text */}
          <div className="w-full md:w-1/2 md:pl-16">
            {/* Mission Section */}
            <div className="mb-12">
              <h2 className="text-accent text-xl font-semibold mb-4">
                Mission
              </h2>
              <p className="text-grayish dark:text-white leading-relaxed text-[18px]">
                To pioneer innovative uses of technology that engages, educates,
                inspires and empowers global citizens to address pressing
                environmental and social challenges collectively.
              </p>
            </div>

            {/* Vision Section */}
            <div>
              <h2 className="text-accent text-xl font-semibold mb-4">Vision</h2>
              <p className="text-grayish dark:text-white leading-relaxed text-[18px]">
                To create a platform at the intersection of profit and purpose
                where technology and creativity converge to drive real-world
                positive outcomes for people, the planet, and impact-aligned
                organizations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PurposeSection;
